<div class="relative">
  <ig-expand-indicator #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" aria-label="open"
    [matTooltip]="isJustAddedPlaces ? 'You need to save the itinerary attraction changes before editing it' : 'Edit attraction'"
    class="" [triggerText]="triggerText" (click)="handleOpen($event, menuTrigger)"></ig-expand-indicator>

  <mat-menu #menu="matMenu" class="ig-text-color-edit ig-iti-att-editor">
    <b class="block px-4 py-1">{{ attraction.item.name }}</b>
    <div class="pb-2 pr-5 pl-4 flex gap-4 items-center cursor-pointer" #iconMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="mapIconMenu" igClickStopPropagation>
      <p>Map icon</p>
      <img src="{{attraction.mapIcon || defaultMapIconUrl}}" alt="" class="w-10">
    </div>
    <div class="pb-0 pr-5 pl-4">
      <ig-field [mode]="'textarea'" [control]="form.get('preDescription')"
        (onInputChange)="onPreDescriptionChange($event)" label="Pre-attraction description"
        igClickStopPropagation></ig-field>
    </div>

    <div class="pb-0 pr-5 pl-4">
      <ig-field [mode]="'textarea'" [control]="form.get('description')" (onInputChange)="onDescriptionChange($event)"
        label="Attraction description" igClickStopPropagation></ig-field>
    </div>

    <div class="pb-0 pr-5 pl-4">
      <ig-field [mode]="'textarea'" [control]="form.get('postDescription')"
        (onInputChange)="onPostDescriptionChange($event)" label="Post-attraction description"
        igClickStopPropagation></ig-field>
    </div>

    <div class="flex justify-around items-center ">
      <ig-attraction-description-generator [itinerary]="itinerary" [parentTrigger]="iconMenuTrigger"
        [isJustAddedPlaces]="isJustAddedPlaces" (generated)="generated($event, menuTrigger)"
        igClickStopPropagation></ig-attraction-description-generator>

      <div class="text-red-600 flex justify-end items-center underline cursor-pointer relative" (click)="remove()"
        igClickStopPropagation>
        <mat-icon>delete_forever</mat-icon>
        <span>Remove this attraction</span>
        <ig-confirm-dialog *ngIf="isShowConfirm" class="bottom-11 w-[220px]" (confirm)="onRemove.emit(attraction)"
          (cancel)="hide()" igClickStopPropagation
          text="Are you sure you want to remove this attraction from the itinerary?"></ig-confirm-dialog>
      </div>
    </div>

  </mat-menu>

  <mat-menu #mapIconMenu="matMenu" class="ig-menu-3">
    <div class="grid-rows-2 gap-2 grid grid-cols-5 p-4 cursor-pointer" igClickStopPropagation>
      <img src="{{defaultMapIconUrl}}" alt="" class="w-12" (click)="selectIcon(defaultMapIconUrl, iconMenuTrigger)">
      <img *ngFor="let icon of mapIcons" src="{{icon}}" alt="" class="w-12" (click)="selectIcon(icon, iconMenuTrigger)">
    </div>

    <div class="px-4 mt-4" igClickStopPropagation>
      <p class="pb-1 text-gray-500">Or, use your own icon</p>
      <ig-image-link-file-selector #imgUploader [compressWidth]="70"
        igClickStopPropagation></ig-image-link-file-selector>

      <div class="mb-4">
        <ig-button cls="w-full" (trigger)="submit($event, iconMenuTrigger)" [isAsync]="true"
          [disabled]="!imgUploader.isValid">Create
        </ig-button>
      </div>
    </div>
  </mat-menu>

</div>